import React from "react";
import { useTranslation } from "react-i18next";

const WebHiClassInfoHome = () => {
    const { t } = useTranslation();

    return (
        <div className="d-flex flex-column w-100 align-items-center" style={{ margin: '10px 0px', wordBreak: 'keep-all', wordWrap: 'break-word' }}>
            <img className="w-100" src="/images/info/main/main03.png" alt="HiClassTV_Pentalk_Main03.png" />
        </div>
    );
}

export default WebHiClassInfoHome;